var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoacc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 233,
    viewBox: "0 0 178 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 232.75V77.5833H33.25V55.4167C33.25 40.0847 38.655 27.0175 49.4649 16.2149C60.2749 5.41237 73.3421 0.00739645 88.6667 7.56541e-06C103.991 -0.00738132 117.062 5.39759 127.879 16.2149C138.697 27.0323 144.098 40.0995 144.083 55.4167V77.5833H177.333V232.75H0ZM104.327 170.827C108.665 166.483 110.833 161.263 110.833 155.167C110.833 149.071 108.665 143.854 104.327 139.517C99.9901 135.18 94.7699 133.007 88.6667 133C82.5634 132.993 77.3469 135.165 73.017 139.517C68.6871 143.869 66.5148 149.086 66.5 155.167C66.4852 161.248 68.6576 166.468 73.017 170.827C77.3764 175.187 82.593 177.355 88.6667 177.333C94.7403 177.311 99.9606 175.143 104.327 170.827ZM55.4167 77.5833H121.917V55.4167C121.917 46.1806 118.684 38.3299 112.219 31.8646C105.753 25.3993 97.9028 22.1667 88.6667 22.1667C79.4306 22.1667 71.5799 25.3993 65.1146 31.8646C58.6493 38.3299 55.4167 46.1806 55.4167 55.4167V77.5833Z",
    fill: "#F0E1CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoacc);
export default __webpack_public_path__ + "static/media/noacc.02461d846d0b862c594b1fcdc4400014.svg";
export { ForwardRef as ReactComponent };